import { useLoading } from "../../contexts/LoadingContext";

const FullScreenLoader = () => {
    const { isLoading } = useLoading();

    if (!isLoading) return null;

    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-white/80 z-[9999]">
            <div className="loader mb-4" />
            <p className="text-lg font-medium text-gray-700 text-primaryColor">Loading, please wait...</p>
        </div>
    );
};

export default FullScreenLoader;
